import { Box, Checkbox, FormControlLabel } from "@mui/material";
import React from "react";
import { Participant, SearchParticipantProps } from "../interfaces/interfaces";
import { SearchParticipantContext } from "../context/searchParticipantContext";
import StyledBadge from "../../../components/styledBadge/StyledBadge";

const FoundCounter = (): React.JSX.Element => {
  const {
    searchParameters,
    setSearchParameters,
  }: {
    searchParameters: SearchParticipantProps;
    setSearchParameters: (searchParameters: SearchParticipantProps) => void;
  } = React.useContext(SearchParticipantContext);

  return (
    <React.Fragment>
      {searchParameters.data !== null && !searchParameters.loading && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            my: 2,
          }}
        >
          <StyledBadge
            sx={{ pr: 1, mr: 4 }}
            badgeContent={
              searchParameters.data.filter(
                (participant: Participant) => participant.status === 0
              ).length
            }
            color="secondary"
          >
            <FormControlLabel
              control={
                <Checkbox
                  onClick={() => {
                    setSearchParameters({
                      ...searchParameters,
                      show: {
                        ...searchParameters.show,
                        active: !searchParameters.show.active,
                      },
                    });
                  }}
                  checked={searchParameters.show.active}
                />
              }
              label="aktiv"
            />
          </StyledBadge>

          <StyledBadge
            sx={{ pr: 1, mr: 4 }}
            badgeContent={
              searchParameters.data.filter(
                (participant: Participant) => participant.status === 1
              ).length
            }
            color="secondary"
          >
            <FormControlLabel
              control={
                <Checkbox
                  onClick={() => {
                    setSearchParameters({
                      ...searchParameters,
                      show: {
                        ...searchParameters.show,
                        inactive: !searchParameters.show.inactive,
                      },
                    });
                  }}
                  checked={searchParameters.show.inactive}
                />
              }
              label="inaktiv"
            />
          </StyledBadge>
        </Box>
      )}
    </React.Fragment>
  );
};

export default FoundCounter;
